import React from 'react';
import { ICreateSettlementFeeForm } from 'types/order/fees/ICreateSettlementItemForm';
import { eFeePropertyNames } from 'types/order/fees/eFeePropertyNames';
import { IBaseDisbursementContainerProps } from './IBaseDisbursementContainerProps';
import { IBaseDisbursementStatusPill } from './IBaseDisbursementStatusPill';
import { IDisbursementFormData } from 'types/order/escrow/IDisbursementFormData';
import { ePermissions } from 'types/administration/userAdministration/ePermissions';
import { eLenderPaid } from '../../../../../ui-toolkit/enums/eLenderPaid';
import { IOrderDetailsData } from '../../../../../ui-toolkit/orders/interfaces/IOrderDetailsData';

export interface IBaseDisbursementType<N> {
  editPermission: ePermissions;
  hasEditPermission?: boolean;

  readPermission: ePermissions;
  hasReadPermission?: boolean;

  type: N;

  create: (
    fee: ICreateSettlementFeeForm,
    order: IOrderDetailsData,
    isSpruceWithZillowEnabled: boolean,
    isZillowClosing: boolean
  ) => IDisbursementFormData;
  container: React.FC<IBaseDisbursementContainerProps>;
  statusPill: React.FC<IBaseDisbursementStatusPill>;
  isReadOnly: (x: IDisbursementFormData) => boolean;
}

export const fieldsToSum = [
  eFeePropertyNames.BorrowerPaidAtClosing,
  eFeePropertyNames.BuyerPaidAtClosing,
  eFeePropertyNames.SellerPaidAtClosing,
  eFeePropertyNames.Amount,
];

export const lenderPaidToInclude = [eLenderPaid.LenderPaidSendingToSpruce, eLenderPaid.TitlePaidNotSending];
